import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { notificationSchema } from "./notification";

// Une notification dont `data.popup` est valide s'affiche aussi en fenêtre tant qu'elle n'est pas lue.
export const notificationPopupSchema = z.object({
  eyebrow: z.string().min(1).max(60).optional(),
  chips: z
    .array(
      z.object({
        label: z.string().min(1).max(60),
        icon: z.enum(["download", "calendar", "gift", "star", "sparkle"]).optional(),
        strong: z.boolean().optional(),
      }),
    )
    .max(3)
    .optional(),
  cta: z
    .object({
      label: z.string().min(1).max(40),
      link: z.string().regex(/^\/(?!\/)/),
    })
    .optional(),
  dismissLabel: z.string().min(1).max(40).optional(),
  highlight: z.enum(["downloads", "ai", "rewards", "fidelity"]).optional(),
});

export type NotificationPopup = z.infer<typeof notificationPopupSchema>;

export const getNotificationPopup = (data: unknown): NotificationPopup | null => {
  if (!data || typeof data !== "object") return null;
  const popup = notificationPopupSchema.safeParse((data as Record<string, unknown>)["popup"]);
  return popup.success ? popup.data : null;
};

export const notificationPopupsSchema = z.object({ items: z.array(notificationSchema) });

export class NotificationPopupsDto extends createZodDto(notificationPopupsSchema) {}
